import SubPageContainer from '@/components/SubPageContainer'

import Home from '@/pages/Home'
import Clients from '@/pages/Clients'
import ClientsNew from '@/pages/ClientsNew'
import ClientsEdit from '@/pages/ClientsEdit'
import ClientsDetails from '@/pages/ClientsDetails'
import ClientsBusinessUnits from '@/pages/ClientsBusinessUnits'
import ClientsBusinessUnitsNew from '@/pages/ClientsBusinessUnitsNew'
import ClientsBusinessUnitsEdit from '@/pages/ClientsBusinessUnitsEdit'
import ClientsBusinessUnitsInvoices from '@/pages/ClientsBusinessUnitsInvoices'
import ClientsBusinessUnitsDevices from '@/pages/ClientsBusinessUnitsDevices'
import ClientsBusinessUnitsDevicesNew from '@/pages/ClientsBusinessUnitsDevicesNew'
import ClientsBusinessUnitsDevicesEdit from '@/pages/ClientsBusinessUnitsDevicesEdit'
import ClientsBusinessUnitsDevicesSourceFile from '@/pages/ClientsBusinessUnitsDevicesSourceFile'
import ClientsCertificates from '@/pages/ClientsCertificates'
import ClientsCertificatesNew from '@/pages/ClientsCertificatesNew'
import ClientsCertificatesEdit from '@/pages/ClientsCertificatesEdit'
import Users from '@/pages/MyCompanyUsers'
import UsersNew from '@/pages/MyCompanyUsersNew'
import UsersEdit from '@/pages/MyCompanyUsersEdit'
import UsersResetPass from '@/pages/MyCompanyUsersResetPass'

import Distributors from '@/pages/Distributors'

export default [
  {
    path: '/clients',
    component: SubPageContainer,
    redirect: {
      name: 'Clients'
    },
    children: [
      {
        path: '/home',
        name: 'Home',
        component: Home,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '',
        name: 'Clients',
        component: Clients
      },
      {
        path: 'new',
        name: 'ClientsNew',
        component: ClientsNew,
        props: true
      },
      {
        path: 'edit/:id',
        name: 'ClientsEdit',
        component: ClientsEdit,
        props (route) {
          const props = { ...route.params }
          props.id = +props.id
          return props
        }
      },
      {
        path: ':id',
        name: 'ClientsDetails',
        component: ClientsDetails,
        props (route) {
          const props = { ...route.params }
          props.id = +props.id
          return props
        }
      },
      {
        path: '/users',
        name: 'Users',
        component: Users
      },
      {
        path: '/users/new',
        name: 'UsersNew',
        component: UsersNew
      },
      {
        path: '/users/:id/edit',
        name: 'UsersEdit',
        component: UsersEdit,
        props (route) {
          const props = { ...route.params }
          props.id = +props.id
          return props
        }
      },
      {
        path: '/users/:id/reset-pass',
        name: 'UsersResetPass',
        component: UsersResetPass,
        props (route) {
          const props = { ...route.params }
          props.id = +props.id
          return props
        }
      },
      {
        path: ':childCompanyId/business-units',
        name: 'ClientsBusinessUnits',
        component: ClientsBusinessUnits,
        props (route) {
          const props = { ...route.params }
          props.childCompanyId = +props.childCompanyId
          return props
        }
      },
      {
        path: ':childCompanyId/business-units/new',
        name: 'ClientsBusinessUnitsNew',
        component: ClientsBusinessUnitsNew,
        props (route) {
          const props = { ...route.params }
          props.childCompanyId = +props.childCompanyId
          return props
        }
      },
      {
        path: ':childCompanyId/business-units/:businessUnitId',
        name: 'ClientsBusinessUnitsEdit',
        component: ClientsBusinessUnitsEdit,
        props (route) {
          const props = { ...route.params }
          props.childCompanyId = +props.childCompanyId
          props.businessUnitId = +props.businessUnitId
          return props
        }
      },
      {
        path: ':childCompanyId/business-units/:businessUnitId/invoices',
        name: 'ClientsBusinessUnitsInvoices',
        component: ClientsBusinessUnitsInvoices,
        props (route) {
          const props = { ...route.params }
          props.childCompanyId = +props.childCompanyId
          props.businessUnitId = +props.businessUnitId
          return props
        }
      },
      {
        path: ':childCompanyId/business-units/:businessUnitId/devices',
        name: 'ClientsBusinessUnitsDevices',
        component: ClientsBusinessUnitsDevices,
        props (route) {
          const props = { ...route.params }
          props.childCompanyId = +props.childCompanyId
          props.businessUnitId = +props.businessUnitId
          return props
        }
      },
      {
        path: ':childCompanyId/business-units/:businessUnitId/devices/new',
        name: 'ClientsBusinessUnitsDevicesNew',
        component: ClientsBusinessUnitsDevicesNew,
        props (route) {
          const props = { ...route.params }
          props.childCompanyId = +props.childCompanyId
          props.businessUnitId = +props.businessUnitId
          return props
        }
      },
      {
        path: ':childCompanyId/business-units/:businessUnitId/devices/:deviceId',
        name: 'ClientsBusinessUnitsDevicesEdit',
        component: ClientsBusinessUnitsDevicesEdit,
        props (route) {
          const props = { ...route.params }
          props.childCompanyId = +props.childCompanyId
          props.businessUnitId = +props.businessUnitId
          props.deviceId = +props.deviceId
          return props
        }
      },
      {
        path: ':childCompanyId/business-units/:businessUnitId/devices/:deviceId/source-file',
        name: 'ClientsBusinessUnitsDevicesSourceFile',
        component: ClientsBusinessUnitsDevicesSourceFile,
        props (route) {
          const props = { ...route.params }
          props.childCompanyId = +props.childCompanyId
          props.businessUnitId = +props.businessUnitId
          props.deviceId = +props.deviceId
          return props
        }
      },
      {
        path: ':childCompanyId/certificates',
        name: 'ClientsCertificates',
        component: ClientsCertificates,
        props (route) {
          const props = { ...route.params }
          props.childCompanyId = +props.childCompanyId
          return props
        }
      },
      {
        path: ':childCompanyId/certificates/new',
        name: 'ClientsCertificatesNew',
        component: ClientsCertificatesNew,
        props (route) {
          const props = { ...route.params }
          props.childCompanyId = +props.childCompanyId
          return props
        }
      },
      {
        path: ':childCompanyId/certificates/:certificateId',
        name: 'ClientsCertificatesEdit',
        component: ClientsCertificatesEdit,
        props (route) {
          const props = { ...route.params }
          props.childCompanyId = +props.childCompanyId
          props.certificateId = +props.certificateId
          return props
        }
      }
    ]
  },
  {
    path: '/distributors',
    name: 'Distributors',
    component: Distributors
  }
]
